import React, {Component} from 'react';
import {Button, Form, Message, Modal} from 'semantic-ui-react';
import axios from 'axios';
import {connect} from 'react-redux';
import {MessagesContext} from '../contexts/messages'
import {readFileAsync} from '../utils/common'
import {toggle} from '../actions/getHelpActions'
import {show as showToast} from '../actions/toastActions'
import {UploadFile} from './messages/partials/uploadFile'
import {CustomModalHeader} from "./custom-common";
import STRATEGIC_PARTNER from "../constants/strategicPartners";

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        user: state.initialData.user,
        show: state.getHelp.show
    }
}

const mapDispatchToProps = dispatch => {
    return {
        showToast: (toastDetails) => dispatch(showToast(toastDetails)),
        toggle: (state) => dispatch(toggle(state)),
    }
};

const defaultState = {
    files: [],
    loading: false,
    message: '',
    subject: '',
    submitError: '',
    uploadFileError: '',
}

class GetHelpModal extends Component {
    static contextType = MessagesContext

    constructor(props) {
        super(props);
        this.state = { ...defaultState };
    }

    handleSubmit = async () => {
        const {refresh} = this.context
        const {user, showToast} = this.props;
        const {subject, message, files} = this.state;
        const fullName = `${user.firstName} ${user.lastName}`;

        this.setState({loading: true, error: null});
        try {
            const attachments = await this.processAttachments(files)

            const payload = {
                name: fullName,
                subject: subject,
                message: message,
                attachments
            };

            await axios.post('/api/member/v2/submitMessage', payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'authToken': this.props.authToken
                }
            });
            refresh()
            this.setState({ ...defaultState });
            showToast({type:'success', message:'Your message has been sent!'})
            this.handleClose();
        } catch (e) {
            this.setState({ loading: false, submitError: 'Unable to submit your message' });
        }
    }

    handleClose = () => {
        const { show, toggle } = this.props;

        if (show) toggle(false);
    }

    handleFilesUpdate = (files) => {
        this.setState({ files })
        if (files.length > 0) {
            this.setState({uploadFileError: ''})
        }
    }

    processAttachments = async (files) => {
        if (!files?.length) return

        return Promise.all(files.map(async file => {
            const content = await readFileAsync(file)
            const contentData = content.split(',')[1]

            return {
                fileName: file.name,
                contentType: file.type,
                contentData
            }
        }))
    }

    renderFormField = (element) => {
        return (
            <div style={{marginTop: '24px'}}>
                {element}
            </div>
        )
    }

    renderSubjectField = () => {
        const { subject, loading } = this.state;
        const field = (
            <Form.Input
                disabled={loading}
                label={"Subject"} required
                value={subject}
                onChange={(_, {value}) => this.setState({subject: value})}
            />
        )
        return this.renderFormField(field)
    }

    renderMessageField = () => {
        const { message, loading } = this.state;
        const field = (
                <Form.TextArea disabled={loading}
                          label={"Message"}
                          value={message}
                          onChange={(_, {value}) => this.setState({message: value})}
                          required
                />
        )
        return this.renderFormField(field)
    }

    renderFileUpload = () => {
        const { files, loading } = this.state;
        const field = (
            <Form.Field>
                <label>{"Attachments"}</label>
                <UploadFile
                    style={{marginTop: '0',}}
                    disabled={loading}
                    files={files}
                    validFileTypes={[
                        'image/jpeg',
                        'image/jpg',
                        'image/png',
                        'application/pdf'
                    ]}
                    onFilesUpdate={files => this.handleFilesUpdate(files)}
                    onError={(error) => this.setState({uploadFileError: error.message})}
                />
            </Form.Field>
        )
        return this.renderFormField(field)
    }

    render() {
        const {subject, message, submitError, loading, uploadFileError} = this.state;
        const {LABEL, CONTACT_SUPPORT: {NUMBER}} = STRATEGIC_PARTNER;

        const spanishHelp = `¿Necesitas ayuda en español? Llama al ${NUMBER} para recibir ayuda.`

        return (
            <Modal size={'tiny'} onClose={this.handleClose} open>
                <CustomModalHeader title={`Message ${LABEL}`} onClose={this.handleClose} className="customModalHeader"/>
                <Modal.Content className={"small"}>
                    <p>Have a question? Send us a note and we’ll get back to you shortly—</p>
                    <Form autoComplete="false">
                        {this.renderSubjectField()}
                        {this.renderMessageField()}
                        {this.renderFileUpload()}
                        <div style={{background: '#F5F6F7', marginTop: '24px', marginBottom: '24px', padding: '24px'}}>
                            {spanishHelp}
                        </div>

                        {!!submitError &&
                        <div><Message negative style={{margin: '0.8em'}}>{submitError}</Message></div>}

                        <div style={{textAlign: 'right'}}>
                            <Button primary basic onClick={this.handleClose} className="clHelpButton">{"Cancel"}</Button>
                            <Button
                                primary
                                loading={loading}
                                disabled={loading || subject.length === 0 || message.length === 0 || uploadFileError}
                                onClick={this.handleSubmit}
                            >{"Submit"}</Button>
                        </div>
                    </Form>
                </Modal.Content>
            </Modal>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GetHelpModal);

